import { render } from "./StockManagement.vue?vue&type=template&id=c339af74&scoped=true"
import script from "./StockManagement.vue?vue&type=script&lang=js"
export * from "./StockManagement.vue?vue&type=script&lang=js"

import "./StockManagement.vue?vue&type=style&index=0&id=c339af74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c339af74"]])

export default __exports__